import { Dialog } from 'primereact/dialog';
import { ModalPositions, ModalProps } from './Modal.types';

const Modal: React.FC<ModalProps> = ({
  children,
  position = ModalPositions.CENTER,
  onClose,
  isOpen,
  modalStyle,
  headerStyle,
  fullScreen,
}) => {
  return (
    <Dialog
      visible={isOpen}
      position={position}
      onHide={onClose}
      className="max-h-full"
      headerClassName={headerStyle}
      closeIcon={
        <div className="flex items-center justify-center bg-[#BD292F] w-[24px]  h-[24px] rounded-[50%] p-2">
          <i className="pi pi-times text-black"></i>
        </div>
      }
      contentClassName={modalStyle}
      maximizable={fullScreen}
    >
      {children}
    </Dialog>
  );
};

export default Modal;
